// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2cB1y","title":"AfterBackImages_title__2L8Pe","images":"AfterBackImages_images__3YzVX"};